/**
   * Function to swap the source with the mobile source if available.
   * @param {Element} video The video element for which the video should be swapped
   * @param {boolean} isMobile Condition to detect screen size
   * @returns {string|boolean} Original source or false if operation failed
 */
export default async function swapVideoSource(video, isMobile = true) {
    // Get primary source of video's first source
    const firstSourceElement = video?.querySelector('source:first-child');
    const firstSource = firstSourceElement ? firstSourceElement.getAttribute("src") : video?.getAttribute("src");
    
    if (!(firstSource && typeof firstSource === "string")) {
        console.log("Error getting current source.");
        return false;
    }
    
    // If desktop, just trigger primary source
    if (!isMobile) {
        video.setAttribute("src", firstSource);
        return false;
    }
    
    // Is this already mobile?
    if (firstSource.substr(0, firstSource.length - 4).substr(-7, 7) === "-mobile") {
        console.log("We already have the mobile version of the video");
        return false;
    }
    
    // Get mobile Url
    const mobileUrl = firstSource.substr(0, firstSource.length - 4) + "-mobile.mp4";
    if (!mobileUrl) {
        console.log("Couldn't evaluate mobile video url.");
        return false;
    }
    
    // HEAD the request to sniff if it is there
    const request = await fetch(mobileUrl, { method: "HEAD" });
    
    // Is it there?
    if (request.status !== 200 && request.headers.get("content-type") !== "video/mp4") {
        console.log("Couldn't find the mobile video, check response.");
        return false;
    }
    
    // Write the valid URL to the source
    video.setAttribute("src", mobileUrl);
    return firstSource;
}